import { BasketMinusIcon } from './BasketMinusIcon';

/**
 * author: Michael Irigoyen
 * id C41B2071-6BBF-458A-B73A-409D231A9F4D
 * name basket-minus
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-minus.svg
 * tags
 * - Shopping 
 */
export const ShoppingBasketMinusIcon = BasketMinusIcon;
export default ShoppingBasketMinusIcon